export enum SituationEnum {
    "", "Ik wil veranderen van leverancier", "Ik verhuis en kies voor Ebem (overname)", "Nieuwe aansluiting op het net (nieuwbouw)", "De aansluiting heropenen na afsluiting"
}